define([
	"dojo/_base/declare",
	"dojo/io-query",
	"./Request"
], function(declare, ioQuery, Request) {

	return declare(Request, {
		allowRetry: true,

		go: function(ioArgs) {
			// summary: common interface for requests
			return this.get(ioArgs);
		},

		get: function(ioArgs) {
			// summary: if no arguments specified, then default to syncrhonous request (for now)
			ioArgs = ioArgs || {};
			ioArgs.url = ioArgs.url || this.toRequest();
			return this._xhr(ioArgs);
		},

		toRequest: function() {
			this._optimize();
			return this.urlBase + ioQuery.objectToQuery(this.content);
		},

		_toXmlRequest: function(/*Object*/ioArgs) {
			// summary: convert url to debug string
			var url = ioArgs.url;
			var n1 = url.indexOf("Qry.URL=");
			if (n1 > 0)
				return unescape((url.indexOf("&", n1) > 0) ? url.substring(n1, url.indexOf("&", n1)) : url.substr(n1));

			n1 = url.indexOf("Module");
			return (n1 > 0) ? url.substr(n1) : url;
		}
	});
});